<template>
  <div class="containerTable" style="padding:15px;">
    <vxe-toolbar
      id="toolbarId_contractBody"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">查询</el-button>
        <el-button
          v-if="getLimit('contract_body_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
        <!--<el-button @click="funcAdd">新增</el-button>-->
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      highlight-hover-row
      row-id="id_contractBody"
      class="mytable-footer"
      height="80%"
      show-overflow
      :data="tableData"
      sort-config.remote
      export-config
      @sort-change="sortList"
    >
      <!--<vxe-table-column>
          <vxe-table-column field="branchCode" title="组织机构编码" min-width="100" sortable />
          <template v-slot:header>
              <el-input v-model="listQuery.branchCode" placeholder="请输入组织机构编码" clearable />
          </template>
      </vxe-table-column>-->
      <vxe-table-column>
        <vxe-table-column
          field="type"
          title="类别"
          width="200"
          :formatter="
            ({ cellValue }) => {
              return types[cellValue];
            }
          "
          clearable
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.type"
            placeholder="请选择类别"
            size="mini"
          >
            <el-option v-for="(v, k) in types" :key="k" :value="k" :label="v" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column field="title" title="标题" sortable />
        <template v-slot:header>
          <el-input
            v-model="listQuery.title"
            placeholder="请输入新闻标题"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" fixed="right" width="100">
        <template slot-scope="scope">
          <!--<el-tooltip class="item" effect="dark" content="详情" placement="top">
              <vxe-button type="text" @click="funcDetail(scope.row.code)">
                  <em class="el-icon-document" />
              </vxe-button>
          </el-tooltip>-->
          <el-tooltip
            v-if="getLimit('contract_body_edit_button')"
            class="item"
            effect="dark"
            content="编辑"
            placement="top"
          >
            <vxe-button type="text" @click="funcEdit(scope.row.code)">
              <em class="el-icon-edit" />
            </vxe-button>
          </el-tooltip>
          <!--<el-tooltip class="item" effect="dark" content="删除" placement="top">
              <vxe-button type="text" @click="funcDelete(scope.row.code)">
                  <em class="el-icon-delete" />
              </vxe-button>
          </el-tooltip>-->
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />

    <vxe-modal
      v-model="modelEditFlag"
      :title="title"
      width="1000"
      height="900"
      resize
    >
      <compEdit
        ref="editRef"
        @fatherEditMethod="fatherEdit"
        @fatherCancelMethod="fatherCancel"
      />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import compEdit from "./components/contractBodyEdit.vue";
import request from "@/utils/request";

export default {
  name: "ContractBodyList",
  components: {
    compEdit
  },
  data() {
    return {
      types: { 1: "托运人合同", 2: "实际承运人合同" },
      exportObj: {
        exportUrl: "/ntocc-basic-api/contractBody/exportContractBody", //导出接口
        name: "合同模板"
      },
      title: "编辑",
      message: "",
      loading: false,
      tableData: [],
      modelEditFlag: false,
      copy: false,
      listQuery: {
        code: "",
        branchCode: "",
        title: "",
        content: "",
        type: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return request({
        url: "/ntocc-basic-api/contractBody",
        method: "get",
        params: this.listQuery
      }).then(response => {
        this.tableData = response.data.records;
        let total = response.data.total;
        this.listQuery.total = total;
        this.loading = false;
      });
    },
    // 添加方法
    funcAdd() {
      this.title = "新增";
      this.$refs.editRef.init(false);
      this.modelEditFlag = true;
    },
    // 修改方法
    funcEdit(code) {
      this.title = "修改";
      this.$refs.editRef.init(false);
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 详情方法
    funcDetail(code) {
      this.title = "详情";
      this.$refs.editRef.init(true);
      this.$refs.editRef.getInfo(code);
      this.modelEditFlag = true;
    },
    // 删除方法
    funcDelete(row) {
      this.$confirm("确认删除吗？")
        .then(_ => {
          request({
            url: `/ntocc-basic-api/contractBody`,
            method: "delete",
            params: { codes: row }
          }).then(response => {
            this.$message({ message: response.msg, type: "success" });
            this.findList();
          });
        })
        .catch(_ => {});
    },
    // 增加组件的父方法
    fatherAdd() {
      this.modelAddFlag = false;
      this.findList();
    },
    // 编辑组件的父方法
    fatherEdit() {
      this.modelEditFlag = false;
      this.findList();
    },
    // 公共取消
    fatherCancel(modelFlag) {
      if (modelFlag == "edit") {
        this.modelEditFlag = false;
      }
    },
    // 底部颜色设置
    footerCellClassName({ $rowIndex, column, columnIndex }) {
      if (columnIndex === 0) {
        if ($rowIndex === 0) {
          return "col-blue";
        } else {
          return "col-red";
        }
      }
    },
    // 设置底部合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["pageviews", "forecast"].includes(column.property)) {
            return this.$XEUtils.sum(data, column.property);
          }
          return null;
        })
      ];
    }
  }
};
</script>
